import api from '@/lib/axios';
import type { Room, CreateRoomDTO, UpdateRoomDTO, ApiResponse, LaravelPaginator } from '@/types';

/**
 * Serviço de quartos.
 * Rotas: /v1/quartos/*
 */
export const roomsService = {
  /**
   * Listar todos os quartos
   * GET /v1/quartos
   */
  async list(params?: { page?: number; per_page?: number; search?: string; status?: string }): Promise<LaravelPaginator<Room>> {
    const { data } = await api.get<ApiResponse<{ rooms: LaravelPaginator<Room> }>>('/v1/quartos', { params });
    return data.data.rooms;
  },

  /**
   * Obter quarto por ID
   * GET /v1/quartos/:id
   */
  async get(id: number): Promise<Room> {
    const { data } = await api.get<ApiResponse<Room>>(`/v1/quartos/${id}`);
    return data.data;
  },

  /**
   * Criar novo quarto
   * POST /v1/quartos
   */
  async create(payload: CreateRoomDTO): Promise<Room> {
    const { data } = await api.post<ApiResponse<Room>>('/v1/quartos', payload);
    return data.data;
  },

  /**
   * Atualizar quarto
   * PUT /v1/quartos/:id
   */
  async update(id: number, payload: UpdateRoomDTO): Promise<Room> {
    const { data } = await api.put<ApiResponse<Room>>(`/v1/quartos/${id}`, payload);
    return data.data;
  },

  /**
   * Deletar quarto
   * DELETE /v1/quartos/:id
   */
  async delete(id: number): Promise<void> {
    await api.delete(`/v1/quartos/${id}`);
  },
};
